import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { ApprobationService } from '../../services/approbation.service';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { UserService } from '../../services/usuario.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-approbation-group-detail',
  templateUrl: 'approbation-group-detail.component.html',
  styleUrls: ['approbation-group-detail.component.scss']
})
export class ApprobationGroupDetailComponent implements OnInit {


  tableSettingsGroupDetail: any = undefined;
  dataSourceGroupDetail: any = undefined;
  tableDataGroupDetail: any = {};
  listTipoDocumento: any = [];
  tipoDocumento: any = 0;
  listUserListAll: any = [];
  tableSettingsGroupDetailIn: any = undefined;
  dataSourceGroupDetailIn: any = undefined;
  tableDataGroupDetailIn: any = {};
  dataSend: any = {};
  idGroup: any = 0;
  listUserIn: any = [];
  listUsuariosAsignados: any = [];
  groupAprobation: any = {};
  dataModal: any = '';
  paramId: any;
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'asignar', title: ` <div class="editCustomButton">Asignar</div>` },

      ]
    }
  };
  settingsIn = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'desasignar', title: ` <div class="editCustomButton">Desasignar</div>` },

      ]
    }
  };



  constructor(private approbationService: ApprobationService,
    private notifierService: NotifierService, private userService: UserService,
    private route: Router,
    private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.idGroup = params['id'];
        this.dataModal = 'ACTUALIZAR';
      } else {
        this.dataModal = 'CREAR';
      }


    });

    this.tableDataGroupDetail = {
      columns: {
        nombres: { title: 'Nombres' },
        apellidos: { title: 'Apellidos' },
        codigo: { title: 'Código' },
      },
      data: {}
    };
    this.tableDataGroupDetailIn = {
      columns: {
        nombres: { title: 'Nombres' },
        apellidos: { title: 'Apellidos' },
        codigo: { title: 'Código' },
      },
      data: {}
    };

    // Obtener los tipo de documentos
    this.approbationService.getTipoDocumento().subscribe((result) => {
      this.listTipoDocumento = result;
    }, (error) => {
      this.notifierService.systemNotify({
        title: 'error',
        message: 'Ha ocurrido un error al obtener los tipos de documentos',
        type: 'error'
      });
    });


  }

  ngOnInit() {



    if (this.idGroup) {// Si esque es edit
      this.approbationService.getInfoGroupAprobation(this.idGroup).subscribe((result) => {
        this.groupAprobation = result[0];

        this.dataSend = {
          fecha_creacion: result[0].fecha_creacion,
          fecha_modificacion: result[0].fecha_modificacion,
          id: result[0].id,
          nombre: result[0].nombre,
          orden: result[0].orden,
          permitir_notificaciones: result[0].permitir_notificaciones,
          tenant: result[0].tenant,
          tipo_aprobacion_id: result[0].tipo_aprobacion_id,
          usuario_creacion: result[0].usuario_creacion,
          usuario_modificacion: result[0].usuario_modificacion,

        };

        this.approbationService.getUserGroupAprobation(this.idGroup).subscribe((ApprobationResult) => {
          this.listUserIn = ApprobationResult;

          this.userService.getUsersList().subscribe((userResult) => {
            this.listUserListAll = userResult;
            // Encontrar los usuarios que no han sido asignados
            const newList = [];
            let found = false;
            for (const userAll of this.listUserListAll) {
              found = false;
              for (const userIn of this.listUserIn) {
                // tslint:disable-next-line:triple-equals
                if (userIn.id == userAll.id) {
                  found = true;
                  break;
                }
              }
              if (!found) {
                newList.push(userAll);
              }
            }
            this.listUserListAll = newList;

            this.getTableDataGroup(this.listUserListAll);
            this.getTableDataGroupIn(this.listUserIn);



          }, (error) => {
            this.notifierService.systemNotify({
              title: 'error',
              message: 'Ha ocurrido un error al obtener los usuarios',
              type: 'error'
            });
          });



        }, (error) => {
          this.notifierService.systemNotify({
            title: 'error',
            message: 'Ha ocurrido un error',
            type: 'error'
          });
        });

      }, (error) => {
        this.notifierService.systemNotify({
          title: 'error',
          message: 'Ha ocurrido un error',
          type: 'error'
        });
      });

    } else {// Si esque es create
      this.getTableDataGroupIn([]);


      this.userService.getUsersList().subscribe((result) => {
        this.listUserListAll = result;
        this.getTableDataGroup(this.listUserListAll);
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'error',
          message: 'Ha ocurrido un error al obtener los usuarios',
          type: 'error'
        });
      });

    }




  }
  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }


  getTableDataGroupIn(result) {
    const cloneRows: Array<any> = [...result];
    for (const item of cloneRows) {
      item.aperture_date = moment(item.aperture_date).format('DD/MM/YYYY');
      item.closed = item.closed === 1 ? 'Cerrado' : 'Abierto';
    }

    this.dataSourceGroupDetailIn = new LocalDataSource(cloneRows);
    this.tableSettingsGroupDetailIn = this.copyObject(this.settingsIn);
    if (this.tableDataGroupDetailIn.columns !== undefined) {
      this.tableSettingsGroupDetailIn.columns = this.copyObject(this.tableDataGroupDetailIn.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsGroupDetailIn.columns).forEach(key => {
        this.tableSettingsGroupDetailIn.columns[key].filter = true;
      });
    }
  }

  getTableDataGroup(result) {
    const cloneRows: Array<any> = [...result];
    for (const item of cloneRows) {
      item.aperture_date = moment(item.aperture_date).format('DD/MM/YYYY');
      item.closed = item.closed === 1 ? 'Cerrado' : 'Abierto';
    }

    this.dataSourceGroupDetail = new LocalDataSource(cloneRows);
    this.tableSettingsGroupDetail = this.copyObject(this.settings);
    if (this.tableDataGroupDetail.columns !== undefined) {
      this.tableSettingsGroupDetail.columns = this.copyObject(this.tableDataGroupDetail.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsGroupDetail.columns).forEach(key => {
        this.tableSettingsGroupDetail.columns[key].filter = true;
      });
    }
  }

  customGroupDetailAction(event) {
    switch (event.action) {
      case 'asignar':
        this.assignUserToGroup(event.data);
        break;
      case 'desasignar':
        this.unassignUserToGroup(event.data);
        break;
    }
  }
  unassignUserToGroup(data) {
    const actualizarUsuarios = [];
    for (const userIn of this.listUserIn) {
      // tslint:disable-next-line:triple-equals
      if (userIn.id != data.id) {
        actualizarUsuarios.push(userIn);
      }
    }
    this.listUserIn = actualizarUsuarios;


    this.listUserListAll.push(data);
    this.getTableDataGroup(this.listUserListAll);
    this.getTableDataGroupIn(this.listUserIn);

  }
  assignUserToGroup(data) {
    const newUser = {
      apellidos: data.apellidos,
      aperture_date: data.aperture_date,
      capacity_hours: data.capacity_hours,
      celular: data.celular,
      closed: data.closed,
      codigo: data.codigo,
      correo: data.correo,
      estado: data.estado,
      id: data.id,
      id_area: data.id_area,
      name_area: data.name_area,
      nombre_completo: data.nombre_completo,
      nombres: data.nombres,
      rol: data.rol,
      rolNombre: data.rolNombre,
      sexo: data.sexo,
      tipo_usuario: data.tipo_usuario,
    };
    this.listUserIn.push(newUser);

    const actualizarUsuarios = [];
    for (const userIn of this.listUserListAll) {
      // tslint:disable-next-line:triple-equals
      if (userIn.id != newUser.id) {
        actualizarUsuarios.push(userIn);
      }
    }
    this.listUserListAll = actualizarUsuarios;
    this.getTableDataGroup(this.listUserListAll);
    this.getTableDataGroupIn(this.listUserIn);

  }

  createGroup(data) {

    if (this.dataSend.nombre && this.dataSend.orden && this.dataSend.tipo_aprobacion_id) {
      // tslint:disable-next-line:triple-equals
      if (this.dataSend.permitir_notificaciones == undefined || this.dataSend.permitir_notificaciones == null) {
        this.dataSend.permitir_notificaciones = false;
      }

      this.dataSend.usuarioGruposAsignados = this.listUserIn;


      this.approbationService.createGroup(this.dataSend).subscribe((result) => {
        this.listTipoDocumento = result;
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha creado el grupo satisfactoriamente',
          type: 'success'
        });
        this.route.navigate(['/system/approbation-group']);


      }, (error) => {
        this.notifierService.systemNotify({
          title: 'error',
          message: 'Ha ocurrido un error al crear los grupos de aprobación',
          type: 'error'
        });
      });
    } else {
      this.notifierService.systemNotify({
        title: 'error',
        message: 'Debe de llenar los campos requeridos',
        type: 'error'
      });
    }
  }
  updateGroup(data) {

    if (this.dataSend.nombre && this.dataSend.orden && this.dataSend.tipo_aprobacion_id) {
      // tslint:disable-next-line:triple-equals
      if (this.dataSend.permitir_notificaciones == undefined || this.dataSend.permitir_notificaciones == null) {
        this.dataSend.permitir_notificaciones = false;
      }
      this.dataSend.usuarioGruposAsignados = this.listUserIn;
      this.approbationService.updateGroup(this.dataSend).subscribe((result) => {
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha modificado el grupo satisfactoriamente',
          type: 'success'
        });
        this.route.navigate(['/system/approbation-group']);
      }, (err) => {
        this.notifierService.systemNotify({
          title: 'error',
          message: 'Ha ocurrido un error',
          type: 'error'
        });
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/system/approbation-group/approbation-group-detail/approbation-group-detail.component.ts